var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentMessagesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.c{fill:#fff;}.b{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.438 -382.97)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.039,405.363h22.9a2.588,2.588,0,0,0,2.586-2.588v-.012l.014-7.193a2.6,2.6,0,0,0-2.6-2.6h-22.9a2.606,2.606,0,0,0-2.6,2.6v7.193A2.608,2.608,0,0,0,31.039,405.363Zm0-8.494a1.3,1.3,0,0,1,1.3-1.3h20.3a1.3,1.3,0,0,1,1.3,1.3v4.246h-22.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(43.417 397.335)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(46.512 397.335)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(49.553 397.335)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentMessagesIcon);
export default __webpack_public_path__ + "static/media/currentMessagesIcon.b5875a00df7e6cfe62f3a470d377bf7b.svg";
export { ForwardRef as ReactComponent };